import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AnaService } from '../../services/ana.service';
import { MatSort, Sort } from '@angular/material/sort';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { AnaCFList, CF } from '../../classes/ana-cf-list.model';

@Component({
  selector: 'molla-customers-list',
  templateUrl: './customers-list.component.html',
  styleUrls: ['./customers-list.component.scss']
})
export class CustomersListComponent implements OnInit, AfterViewInit {
  @Input() COD_AGE: string;

  loaded = false;
  iCliAge!: AnaCFList;
  perPage = 10;
  totalCount = 0;
  currentPage = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  displayedColumns: string[] = ['COD_CF', 'RAG_SOC_CF', 'P_IVA_CF', 'COMUNE_CF', 'TEL_CF'];
  // Additional 'filter' column list
  displayedColumnFilters: string[] = ['COD_CF-filter', 'RAG_SOC_CF-filter', 'P_IVA_CF-filter', 'COMUNE_CF-filter', 'TEL_CF-filter'];
  model: NgbDateStruct;
  date: { year: number; month: number };

  dataSource = new MatTableDataSource<CF>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  public objFiltri: any = {
    COD_CF: '',
    RAG_SOC_CF: '',
    P_IVA_CF: '',
    COMUNE_CF: ''
  };

  constructor(
    private anaService: AnaService,
    private _liveAnnouncer: LiveAnnouncer
  ) {

  }

  ngOnInit(): void {
    //console.log("Received COD_AGE:", this.COD_AGE);
    this.loadData();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  async loadData() {
    try {

      this.iCliAge = await this.anaService.fetchCliList(
        this.COD_AGE,
        this.COD_AGE,
        this.objFiltri.COD_CF,
        this.objFiltri.RAG_SOC_CF,        
        this.objFiltri.P_IVA_CF,
        this.objFiltri.COMUNE_CF);

      if (this.iCliAge) {
        this.dataSource.data = this.iCliAge.cf;
        this.dataSource.sort = this.sort;

        setTimeout(() => {
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = Number(this.iCliAge.totalCount);
        });

        this.loaded = true;
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }

  pageChanged(event: PageEvent) {
    this.loaded = false;
    this.perPage = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  filterchanged(event: any, columnName: string): void {
    const filterValue = event.target.value;

    switch (columnName) {
      case 'COD_CF':
        this.objFiltri.DOC_ID = filterValue;
        break;
      case 'RAG_SOC_CF':
        this.objFiltri.RAG_SOC_CF = filterValue;
        break;
      case 'P_IVA_CF':
        this.objFiltri.P_IVA_CF = filterValue;
        break;
      case 'COMUNE_CF':
        this.objFiltri.COMUNE_CF = filterValue;
        break;
      // Aggiungi altri casi per le colonne aggiuntive
      default:
        break;
    }

    this.loadData();
  }

}
